import { useMemo, useState } from 'react';

export const useFormatDate = () => {
  const today = new Date();
  const [currentDate, setCurrentDate] = useState<{
    year: number;
    month: number;
    day: number;
  }>({
    year: today.getFullYear(),
    month: today.getMonth() + 1,
    day: today.getDate()
  });
  const formattedDate = useMemo(() => {
    const formattedMonth = String(currentDate.month).padStart(2, '0');
    const formattedDay = String(currentDate.day).padStart(2, '0');

    return `${currentDate.year}-${formattedMonth}-${formattedDay}`;
  }, [currentDate]);

  return {
    currentDate,
    setCurrentDate,
    formattedDate
  };
};
